const lb = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Lueden...',
    error: 'Feeler',
    save: 'Späicheren',
    cancel: 'Ofbriechen',
    delete: 'Läschen',
    edit: 'Änneren',
    create: 'Erstellen',
    add: 'Derbäisetzen',
    remove: 'Ewechhuelen',
    close: 'Zoumaachen',
    confirm: 'Bestätegen',
    apply: 'Uwenden',
    reset: 'Zrécksetzen',
    search: 'Sichen',
    filter: 'Filteren',
    clear: 'Eidel maachen',
    back: 'Zréck',
    next: 'Nächst',
    previous: 'Vireg',
    submit: 'Aschécken',
    update: 'Aktualiséieren',
    refresh: 'Aktualiséieren',
    export: 'Exportéieren',
    import: 'Importéieren',
    download: 'Eroflueden',
    upload: 'Eroplueden',
    print: 'Drécken',
    copy: 'Kopéieren',
    yes: 'Jo',
    no: 'Nee',
    ok: 'OK',
    done: 'Fäerdeg',
    select: 'Auswielen',
    selectAll: 'Alles auswielen',
    deselectAll: 'Alles ofwielen',
    noResults: 'Keng Resultater fonnt',
    noData: 'Keng Daten disponibel',
    required: 'Obligatoresch',
    optional: 'Fakultativ',
    actions: 'Aktiounen',
    details: 'Detailer',
    overview: 'Iwwersiicht',
    summary: 'Zesummefaassung',
    total: 'Gesamt',
    all: 'All',
    none: 'Keen',
    name: 'Numm',
    type: 'Typ',
    status: 'Status',
    date: 'Datum',
    time: 'Zäit',
    description: 'Beschreiwung',
    notes: 'Notizen',
    comments: 'Kommentaren',
    category: 'Kategorie',
    priority: 'Prioritéit',
    nation: 'Natioun',
    country: 'Land',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adress',
    location: 'Standuert',
    coordinates: 'Koordinaten',
    latitude: 'Breedegréid',
    longitude: 'Längegréid',
    from: 'Vun',
    to: 'Bis',
    createdAt: 'Erstallt',
    updatedAt: 'Aktualiséiert',
    createdBy: 'Erstallt vun',
    modifiedBy: 'Geännert vun',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktivéiert',
    disabled: 'Desaktivéiert',
    showing: 'Weist',
    of: 'vun',
    page: 'Säit',
    perPage: 'pro Säit',
    rows: 'Zeilen',
    items: 'Elementer',
    results: 'Resultater',
    sortBy: 'Sortéieren no',
    ascending: 'Opsteigend',
    descending: 'Ofsteigend',
    viewAll: 'Alles gesinn',
    viewDetails: 'Detailer gesinn',
    goBack: 'Zréck goen',
    learnMore: 'Méi gewuer ginn',
    seeMore: 'Méi gesinn',
    showMore: 'Méi weisen',
    showLess: 'Manner weisen',
    expandAll: 'Alles opklappen',
    collapseAll: 'Alles zouklappen',
    copied: 'Kopéiert!',
    saved: 'Gespäichert!',
    deleted: 'Geläscht!',
    updated: 'Aktualiséiert!',
    created: 'Erstallt!',
    success: 'Erfolleg',
    warning: 'Warnung',
    info: 'Informatioun',
    danger: 'Gefor',
    unknown: 'Onbekannt',
    notAvailable: 'Net disponibel',
    never: 'Ni',
    today: 'Haut',
    yesterday: 'Gëschter',
    tomorrow: 'Muer',
    now: 'Elo',
    ago: 'hier',
    justNow: 'grad elo',
    minutesAgo: 'virun {{count}} Min.',
    hoursAgo: 'virun {{count}} St.',
    daysAgo: 'virun {{count}} D.',
    monthsAgo: 'virun {{count}} Mnt.',
    id: 'ID',
    version: 'Versioun',
    language: 'Sprooch',
    theme: 'Thema',
    darkMode: 'Dunkelen Modus',
    lightMode: 'Hellen Modus',
    failedToLoad: 'Daten konnten net geluede ginn',
    failedToSave: 'Späicheren ass feelgeschloen',
    failedToDelete: 'Läschen ass feelgeschloen',
    failedToUpdate: 'Aktualiséieren ass feelgeschloen',
    confirmDelete: 'Sidd Dir sécher, datt Dir dëst läsche wëllt?',
    confirmAction: 'Sidd Dir sécher?',
    unsavedChanges: 'Dir hutt net gespäichert Ännerungen. Sidd Dir sécher, datt Dir fortfuere wëllt?',
    pageNotFound: '404 – Säit net fonnt',
    pageNotFoundDesc: 'Déi Säit, déi Dir sicht, existéiert net.',
    backToDashboard: 'Zréck zum Tableau de bord',
    characters: 'Zeechen',
    maxCharacters: 'Maximal {{max}} Zeechen',
    remaining: '{{count}} iwwreg',
    selected: '{{count}} ausgewielt',
    of_total: '{{count}} vun {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Tableau de bord',
    requests: 'Ufroen',
    transports: 'Transporten',
    myPatients: 'Meng Patienten',
    statistics: 'Statistiken',
    flow: 'Flux',
    resources: 'Resources',
    exercise: 'Exercice',
    administration: 'Administratioun',
    map: 'Kaart',
    info: 'Informatioun',
    users: 'Benotzer',
    assets: 'Ressourcen',
    hubs: 'Knotepunkten',
    treatmentFacilities: 'Behandlungsarichtungen',
    patientImport: 'Patientenimport',
    assetTemplates: 'Ressourceschablounen',
    dayTemplates: 'Dagsschablounen',
    announcementTicker: 'Annoncëband',
    exerciseStatistics: 'Exercice-Statistiken',
    settings: 'Astellungen',
    auditLog: 'Audit-Protokoll',
    exerciseControl: 'Exercice-Kontroll',
    dataSync: 'Datensynchroniséierung',
    documentation: 'Dokumentatioun',
    support: 'Support',
    about: 'Iwwer',
    assetContracts: 'Asset Contracts',
    notifications: 'Notifikatiounen',
    schedules: 'Zäitpläng',
    capacityPlanning: 'Kapazitéitsplanung',
    transportPlanning: 'Transportplanung',
    transportBooking: 'Transportbuchung',
    flowDiagram: 'Fluxdiagramm',
    changePassword: 'Passwuert änneren',
    missions: 'Missiounen',
    startPoints: 'Startpunkten',
    hospital: 'Spidol',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Aloggen',
    logout: 'Ausloggen',
    logoutNow: 'Elo ausloggen',
    loggingIn: 'Umellen...',
    loginFailed: 'Umeldung feelgeschloen',
    email: 'E-Mail',
    password: 'Passwuert',
    username: 'Benotzernumm',
    enterEmail: 'Gitt Är E-Mail-Adress an',
    enterPassword: 'Gitt Äert Passwuert an',
    enterUsername: 'Gitt Äre Benotzernumm an',
    forgotPassword: 'Passwuert vergiess?',
    forgotPasswordTitle: 'Passwuert vergiess',
    forgotPasswordDesc: 'Gitt Äre Benotzernumm an Är E-Mail-Adress an. Wann béides stëmmt, ginn d\'Administrateuren iwwer eng Passwuertzréckstellung informéiert.',
    requestPasswordReset: 'Passwuertzréckstellung ufroen',
    sending: 'Schéckt...',
    backToLogin: 'Zréck zum Login',
    pleaseWait: 'Waart w.e.g. ier Dir et nach eng Kéier probéiert.',
    requestFailed: 'Ufro feelgeschloen',
    credentialsMatch: 'Wann d\'Umeldungsdaten stëmmen, goufen d\'Administrateuren informéiert.',
    forAccess: 'Fir Zougang, kontaktéiert w.e.g. Ären Systemadministrateur.',
    changePassword: 'Passwuert änneren',
    currentPassword: 'Aktuellt Passwuert',
    newPassword: 'Neit Passwuert',
    confirmPassword: 'Passwuert bestätegen',
    passwordChanged: 'Passwuert erfollegräich geännert',
    passwordMismatch: 'Passwierder stëmmen net iwwerteneen',
    passwordTooShort: 'Passwuert muss mindestens 8 Zeechen hunn',
    changingPassword: 'Ännert...',
    mustChangePassword: 'Dir musst Äert Passwuert ännere ier Dir weiderfuere kënnt.',
    sessionExpiring: 'Sëtzung leeft of',
    sessionExpireText: 'Är Sëtzung leeft a(n) <strong>{{time}}</strong> of. Späichert Är Aarbecht a loggt Iech nach eng Kéier an fir weiderzefueren.',
    dismiss: 'Ofweisen',
    switchNation: 'Natioun wiesselen',
    returnTo: 'Zréck op {{nation}}',
    viewingAs: 'Dir kuckt als',
    loggedInAs: 'ageloggt als {{nation}}',
    trainingMode: 'NUR FIR TRAININGSZWECKER',
    dedication: 'Mat Léift an Engagement fir de Beruff geschafen',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Systemadministrateur',
    excon: 'Exercice-Kontroller',
    eu: 'EU-Koordinateur',
    planner: 'Planer',
    hub: 'Knotepunktmanager',
    nation: 'Natioun',
    readOnly: 'Nëmmen liesen',
    systemAdmin: 'Systemadministrateur',
    transportPlanner: 'Transportplaner',
    systemRoles: 'Systemrollen',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Entworf',
    underReview: 'An der Iwwerpréiwung',
    published: 'Publizéiert',
    underSelection: 'An der Auswiel',
    accepted: 'Akzeptéiert',
    planned: 'Geplangt',
    inTransit: 'Am Transport',
    completed: 'Ofgeschloss',
    closed: 'Zou',
    withdrawn: 'Zréckgezunn',
    pending: 'Oppen',
    rejected: 'Ofgeleent',
    cancelled: 'Annuléiert',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    review: 'Iwwerpréiwung',
    selection: 'Auswiel',
    transit: 'Transport',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personal',
    material: 'Material',
    equipment: 'Equipement',
    other: 'Anerer',
    news: 'Neiegkeeten',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Routine',
    priority: 'Prioritéit',
    urgent: 'Dringend',
    immediate: 'Direkt',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Zuch',
    ship: 'Schëff',
    aircraft: 'Fliger',
    bus: 'Bus',
    ambulance: 'Ambulanz',
    drone: 'Dron',
    helicopter: 'Helikopter',
    ferry: 'Fär',
    other: 'Anerer',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Tableau de bord',
    goodMorning: 'Gudde Moien',
    goodAfternoon: 'Gudde Mëtteg',
    goodEvening: 'Gudden Owend',
    lastLogin: 'Lescht Umeldung',
    infrastructure: 'Infrastruktur',
    transportAssets: 'Transportressourcen',
    treatmentFacilities: 'Behandlungsarichtungen',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Ufro-Statistiken',
    viewAllRequests: 'All Ufroen gesinn',
    availableAssets: 'Disponibel Ressourcen',
    seated: 'Sëtzend',
    lying: 'Leiend',
    intensive: 'Intensiv',
    notifications: 'Notifikatiounen',
    markAllRead: 'All als gelies markéieren',
    noNotifications: 'Nach keng Notifikatiounen',
    notifiedWhenActivity: 'Dir gitt informéiert wann nei Aktivitéit stattfënnt',
    viewDetailsBtn: 'Detailer gesinn',
    nationUsers: 'Natiouns-Benotzer',
    user: 'Benotzer',
    roles: 'Rollen',
    noUsersFound: 'Keng Benotzer fonnt',
    participatingNations: 'Deelhuelnend Natiounen',
    exerciseDisclaimer: 'Dëse System ass nëmme fir Exercice-Zwecker. Gitt ausschliisslech simuléiert Exercice-Daten an. D\'Aarbechtsofleef sinn un den Exercice-Szenario ugepasst a kënnen vun reelle Prozedure ofwäichen. IT-Sécherheets- a Dateschutzregele gëllen oneingeschränkt.',
    notConfigured: 'Net konfiguréiert',
    requestCount: '{{count}} Ufro(en)',
    clickToView: 'Klickt fir ze gesinn',
    systemAdministration: 'Systemadministratioun',
    exerciseControlTitle: 'Exercice-Kontroll',
    euCoordination: 'EU-Koordinatioun',
    transportPlanningTitle: 'Transportplanung',
    hubManagement: 'Knotepunktgestioun',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nei Ufro',
    myDrafts: 'Meng Entwërf',
    pendingReview: 'Waart op Iwwerpréiwung',
    activeTransports: 'Aktiv Transporten',
    myPatients: 'Meng Patienten',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Ufroen',
    newRequest: 'Nei Ufro',
    createRequest: 'Ufro erstellen',
    editRequest: 'Ufro änneren',
    requestDetail: 'Ufro-Detailer',
    requestId: 'Ufro-ID',
    fromNation: 'Vun Natioun',
    toNation: 'U Natioun',
    requestingNation: 'Ufroend Natioun',
    receivingNation: 'Empfangend Natioun',
    category: 'Kategorie',
    urgency: 'Drénglechkeet',
    status: 'Status',
    patients: 'Patienten',
    patientCount: 'Unzuel Patienten',
    offers: 'Offeren',
    offerCount: 'Unzuel Offeren',
    created: 'Erstallt',
    updated: 'Aktualiséiert',
    submittedBy: 'Agereecht vun',
    reviewedBy: 'Iwwerpréift vun',
    description: 'Beschreiwung',
    medicalDetails: 'Medizinesch Detailer',
    transportDetails: 'Transportdetailer',
    additionalInfo: 'Zousätzlech Informatiounen',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Offahrtspunkt',
    arrivalPoint: 'Ukonfspunkt',
    estimatedDeparture: 'Geschaten Offaart',
    estimatedArrival: 'Geschaten Ukonft',
    submitForReview: 'Zur Iwwerpréiwung aschécken',
    publish: 'Publizéieren',
    startSelection: 'Auswiel starten',
    acceptOffer: 'Offer akzeptéieren',
    markInTransit: 'Als am Transport markéieren',
    markCompleted: 'Als ofgeschloss markéieren',
    closeRequest: 'Ufro zoumaachen',
    withdrawRequest: 'Ufro zréckzéien',
    withdraw: 'Zréckzéien',
    revertToDraft: 'Zréck zum Entworf',
    deleteRequest: 'Ufro läschen',
    duplicateRequest: 'Ufro duplizéieren',
    createFollowUp: 'Konsolidéiert Ufro erstellen',
    followUpRequest: 'Konsolidéiert Ufro',
    parentRequest: 'Originell Ufro',
    childRequests: 'Konsolidéiert Ufroen',
    noRequests: 'Keng Ufroen fonnt',
    noOffers: 'Nach keng Offeren',
    addPatient: 'Patient derbäisetzen',
    removePatient: 'Patient ewechhuelen',
    patientDetails: 'Patientendetailer',
    contactPerson: 'Kontaktpersoun',
    contactPhone: 'Kontakttelefon',
    contactEmail: 'Kontakt-E-Mail',
    specialRequirements: 'Speziell Ufuerderungen',
    medicalEquipment: 'Medizinescht Equipement',
    accompaniment: 'Begleedung',
    timeline: 'Zäitlinn',
    history: 'Geschicht',
    addComment: 'Kommentar derbäisetzen',
    writeComment: 'Schreift e Kommentar...',
    postComment: 'Kommentar verëffentlechen',
    posting: 'Verëffentlecht...',
    noComments: 'Nach keng Kommentaren',
    coverageBar: 'Ofdeckung',
    covered: 'ofgedeckt',
    uncovered: 'net ofgedeckt',
    filterByStatus: 'No Status filteren',
    filterByCategory: 'No Kategorie filteren',
    filterByNation: 'No Natioun filteren',
    searchRequests: 'Ufroen sichen...',
    confirmWithdraw: 'Sidd Dir sécher, datt Dir dës Ufro zréckzéie wëllt?',
    confirmDelete: 'Sidd Dir sécher, datt Dir dës Ufro läsche wëllt?',
    confirmPublish: 'Sidd Dir sécher, datt Dir dës Ufro publizéiere wëllt? Si gëtt fir all Natiounen siichtbar.',
    confirmStartSelection: 'Sidd Dir sécher, datt Dir d\'Auswiel starte wëllt? Natiounen kënne Offeren ofginn.',
    warningStartSelection: 'D\'Auswiel starten mécht dës Ufro fir all deelhuelnend Natiounen siichtbar. Si kënnen Offere fir d\'Patiente vun dëser Ufro aschécken. Dës Aktioun kann net réckgängeg gemaach ginn.',
    warningMakeOffer: 'Andeems Dir dës Offer aschéckt, verpflicht Dir Är Natioun déi proposéiert Hëllef ze leeschten. Dës Aktioun informéiert déi ufroend Natioun an d\'Exercice-Kontroll.',
    saveDraft: 'Entworf späicheren',
    saving: 'Späichert...',
    saveAndSubmit: 'Späicheren an aschécken',
    step: 'Schrëtt {{number}}',
    generalInfo: 'Allgemeng Informatiounen',
    patientInfo: 'Patienteninformatiounen',
    logisticsInfo: 'Logistikinformatiounen',
    reviewSubmit: 'Iwwerpréiwen an aschécken',
    requestTitle: 'Ufro-Titel',
    requestDescription: 'Ufro-Beschreiwung',
    numberOfPatients: 'Unzuel Patienten',
    typeOfAssistance: 'Aart vun der Hëllef',
    medicalTreatment: 'Medizinesch Behandlung',
    transportAssistance: 'Transporthëllef',
    both: 'Béides',
    treatmentOnly: 'Nëmmen Behandlung',
    transportOnly: 'Nëmmen Transport',
    validationErrors: 'Korrigéiert w.e.g. déi folgend Feeler:',
    fieldRequired: 'Dëst Feld ass obligatoresch',
    selectExitHub: 'Ausgangsknotepunkt auswielen',
    createExitHub: 'Ausgangsknotepunkt erstellen',
    backToRequests: 'Zréck zu den Ufroen',
    noRequestsFound: 'Keng Ufroen fonnt',
    createFirstRequest: 'Erstellt Är éischt Ufro fir unzefänken',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Offeren',
    createOffer: 'Offer erstellen',
    makeOffer: 'Offer maachen',
    manageOffers: 'Offeren geréieren',
    offerDetail: 'Offerdetailer',
    offerId: 'Offer-ID',
    offeringNation: 'Offréierend Natioun',
    offerType: 'Offertyp',
    treatment: 'Behandlung',
    transport: 'Transport',
    combined: 'Kombinéiert',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Behandlungsoffer',
    transportOffer: 'Transportoffer',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Patiente auswielen',
    selectedPatients: 'Ausgewielt Patienten',
    patientSelection: 'Patientenauswiel',
    offerConfiguration: 'Offerkonfiguratioun',
    reviewOffer: 'Offer iwwerpréiwen',
    submitOffer: 'Offer aschécken',
    submitting: 'Schéckt...',
    acceptOffer: 'Offer akzeptéieren',
    rejectOffer: 'Offer oflehnen',
    withdrawOffer: 'Offer zréckzéien',
    noOffers: 'Keng Offeren disponibel',
    noOffer: 'No Offer',
    offerStatus: 'Offerstatus',
    offerDate: 'Offerdatum',
    transportAsset: 'Transportressource',
    departureDate: 'Offahrtsdatum',
    arrivalDate: 'Ukonftsdatum',
    treatmentFacility: 'Behandlungsariichtung',
    capacity: 'Kapazitéit',
    availableCapacity: 'Disponibel Kapazitéit',
    totalCapacity: 'Gesamtkapazitéit',
    selectAsset: 'Ressource auswielen',
    selectFacility: 'Ariichtung auswielen',
    offerNotes: 'Offernotizen',
    confirmAccept: 'Sidd Dir sécher, datt Dir dës Offer akzeptéiere wëllt?',
    confirmReject: 'Sidd Dir sécher, datt Dir dës Offer oflehne wëllt?',
    extendTransport: 'Transport verlängeren',
    transportExtension: 'Transportverlängerung',
    comparisonView: 'Vergläichsansiicht',
    shortlist: 'Auswielllëscht',
    addToShortlist: 'Op d\'Auswielllëscht setzen',
    removeFromShortlist: 'Vun der Auswielllëscht ewechhuelen',
    leaveConfirmTitle: 'Dës Säit verloossen?',
    leaveConfirmMessage: 'Dir hutt net gespäichert Ännerungen. Sidd Dir sécher, datt Dir verloossen wëllt?',
    stayOnPage: 'Op der Säit bleiwen',
    leavePage: 'Säit verloossen',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporten',
    missionDetail: 'Transportdetailer',
    missionId: 'Transport-ID',
    missionStatus: 'Transportstatus',
    createMission: 'Transport erstellen',
    overview: 'Iwwersiicht',
    patientsTab: 'Patienten',
    transportsTab: 'Transportetappen',
    treatmentTab: 'Behandlung',
    reviewTab: 'Iwwerpréiwung',
    departure: 'Offaart',
    arrival: 'Ukonft',
    origin: 'Hierkommen',
    destination: 'Destinatioun',
    stops: 'Haltestellen',
    addStop: 'Haltestell derbäisetzen',
    removeStop: 'Haltestell ewechhuelen',
    stopName: 'Numm vun der Haltestell',
    stopType: 'Typ vun der Haltestell',
    estimatedTime: 'Geschaten Zäit',
    actualTime: 'Tatsächlech Zäit',
    asset: 'Ressource',
    driver: 'Chauffeur',
    crew: 'Equipage',
    noMissions: 'Keng Transporten fonnt',
    completeMission: 'Transport ofschléissen',
    cancelMission: 'Transport annuléieren',
    startTransport: 'Transport starten',
    missionChain: 'Transportketten',
    linkedMissions: 'Verknëppten Transporten',
    handover: 'Iwwergab',
    handoverPoint: 'Iwwergabpunkt',
    pickupPoint: 'Ofholpunkt',
    dropoffPoint: 'Ofsetzpunkt',
    searchTransports: 'Transporten sichen...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patienten',
    myPatients: 'Meng Patienten',
    patientId: 'Patienten-ID',
    firstName: 'Virnumm',
    lastName: 'Nonumm',
    dateOfBirth: 'Gebuertsdatum',
    age: 'Alter',
    gender: 'Geschlecht',
    male: 'Männlech',
    female: 'Weiblech',
    other: 'Anerer',
    nationality: 'Nationalitéit',
    diagnosis: 'Diagnos',
    condition: 'Zoustand',
    stable: 'Stabil',
    critical: 'Kritesch',
    serious: 'Eescht',
    treatmentNeeded: 'Behandlung néideg',
    allergies: 'Allergien',
    medications: 'Medikamenter',
    bloodType: 'Bluttgrupp',
    weight: 'Gewiicht (kg)',
    infectious: 'Infektiéis',
    mentalHealth: 'Psychesch Gesondheet',
    mobility: 'Mobilitéit',
    ambulatory: 'Gehfäeg',
    wheelchair: 'Rollstull',
    stretcher: 'Brancard',
    intensive: 'Intensivpfleg',
    oxygenRequired: 'Sauerstoff néideg',
    ventilator: 'Beatmungsapparat',
    medicalEscort: 'Medizinesch Begleedung',
    noPatients: 'Keng Patiente fonnt',
    patientDetails: 'Patientendetailer',
    medicalHistory: 'Medizinesch Geschicht',
    travelDocuments: 'Reesdokumenter',
    passport: 'Pass',
    pseudonymizedId: 'Pseudonymiséiert ID',
    sensitiveData: 'Sensibel Daten',
    journey: 'Patienterees',
    assignedTo: 'Zougewisen un',
    currentLocation: 'Aktuellen Standuert',
    importPatients: 'Patiente importéieren',
    exportPatients: 'Patiente exportéieren',
    seated: 'Sëtzend',
    lying: 'Leiend',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Benotzer',
    createUser: 'Benotzer erstellen',
    editUser: 'Benotzer änneren',
    deleteUser: 'Benotzer läschen',
    username: 'Benotzernumm',
    displayName: 'Uweisungsnumm',
    email: 'E-Mail',
    password: 'Passwuert',
    role: 'Roll',
    roles: 'Rollen',
    nation: 'Natioun',
    active: 'Aktiv',
    lastLogin: 'Lescht Umeldung',
    createdAt: 'Erstallt',
    isNation: 'Natioun',
    isEU: 'EU',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planer',
    isHub: 'Knotepunkt',
    isReadOnly: 'Nëmmen liesen',
    noUsers: 'Keng Benotzer fonnt',
    confirmDelete: 'Sidd Dir sécher, datt Dir dëse Benotzer läsche wëllt?',
    resetPassword: 'Passwuert zrécksetzen',
    generatePassword: 'Passwuert generéieren',
    searchUsers: 'Benotzer sichen...',
    userCreated: 'Benotzer erfollegräich erstallt',
    userUpdated: 'Benotzer erfollegräich aktualiséiert',
    userDeleted: 'Benotzer erfollegräich geläscht',
    selectNation: 'Eng Natioun auswielen',
    mustChangePassword: 'Passwuert bei nächster Umeldung änneren',
    flagImage: 'Fändelsbild',
    exportUsers: 'Benotzer exportéieren',
    importUsers: 'Benotzer importéieren',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Ressourcen',
    createAsset: 'Ressource erstellen',
    editAsset: 'Ressource änneren',
    deleteAsset: 'Ressource läschen',
    assetName: 'Ressourcennumm',
    assetType: 'Ressourcentyp',
    capacitySeated: 'Kapazitéit (sëtzend)',
    capacityLying: 'Kapazitéit (leiend)',
    capacityIntensive: 'Kapazitéit (intensiv)',
    owner: 'Besëtzer',
    operator: 'Operateur',
    baseLocation: 'Basisstanduert',
    range: 'Räichwäit',
    speed: 'Vitess',
    noAssets: 'Keng Ressource fonnt',
    confirmDelete: 'Sidd Dir sécher, datt Dir dës Ressource läsche wëllt?',
    searchAssets: 'Ressource sichen...',
    assetCreated: 'Ressource erfollegräich erstallt',
    assetUpdated: 'Ressource erfollegräich aktualiséiert',
    assetDeleted: 'Ressource erfollegräich geläscht',
    exportAssets: 'Ressourcen exportéieren',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Knotepunkten',
    startPoints: 'Startpunkten',
    createHub: 'Knotepunkt erstellen',
    editHub: 'Knotepunkt änneren',
    deleteHub: 'Knotepunkt läschen',
    hubName: 'Knotepunktnumm',
    hubType: 'Knotepunkttyp',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Agangsknotepunkt',
    airport: 'Fluchhafen',
    seaport: 'Seehafen',
    railStation: 'Gare',
    roadPoint: 'Stroossepunkt',
    ucpmClassification: 'UCPM-Klassifizéierung',
    icaoCode: 'ICAO-Code',
    iataCode: 'IATA-Code',
    noHubs: 'Keng Knotepunkte fonnt',
    confirmDelete: 'Sidd Dir sécher, datt Dir dëse Knotepunkt läsche wëllt?',
    searchHubs: 'Knotepunkte sichen...',
    nationAssignment: 'Natiounszoustellung',
    assignNations: 'Natiounen zoustellen',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Behandlungsarichtungen',
    createFacility: 'Ariichtung erstellen',
    editFacility: 'Ariichtung änneren',
    deleteFacility: 'Ariichtung läschen',
    facilityName: 'Ariichtungsnumm',
    facilityType: 'Ariichtungstyp',
    hospitalName: 'Spidolsnumm',
    bedCapacity: 'Bettekapazitéit',
    specialties: 'Spezialitéiten',
    availableBeds: 'Disponibel Better',
    totalBeds: 'Better gesamt',
    contactPerson: 'Kontaktpersoun',
    noFacilities: 'Keng Behandlungsarichtunge fonnt',
    confirmDelete: 'Sidd Dir sécher, datt Dir dës Ariichtung läsche wëllt?',
    searchFacilities: 'Ariichtunge sichen...',
    hubNationAssignment: 'Knotepunkt-Natiounszoustellung',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Zäitpläng',
    createSchedule: 'Zäitplang erstellen',
    editSchedule: 'Zäitplang änneren',
    deleteSchedule: 'Zäitplang läschen',
    scheduleName: 'Numm vum Zäitplang',
    scheduleType: 'Typ vum Zäitplang',
    recurring: 'Wiederkeerend',
    oneTime: 'Eemoleg',
    frequency: 'Frequenz',
    daily: 'Deeglech',
    weekly: 'Wëchentlech',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    departureTime: 'Offahrtszäit',
    arrivalTime: 'Ukonftszäit',
    stops: 'Haltestellen',
    addStop: 'Haltestell derbäisetzen',
    noSchedules: 'Keng Zäitpläng fonnt',
    bookings: 'Buchungen',
    timeline: 'Zäitlinn',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notifikatiounen',
    markAllRead: 'All als gelies markéieren',
    markAsRead: 'Als gelies markéieren',
    markAsUnread: 'Als ongelies markéieren',
    noNotifications: 'Keng Notifikatiounen',
    viewAll: 'All Notifikatiounen gesinn',
    settings: 'Notifikatiounsastellungen',
    emailNotifications: 'E-Mail-Notifikatiounen',
    inAppNotifications: 'App-Notifikatiounen',
    notifyOn: 'Mech informéieren iwwer',
    requestCreated: 'Nei Ufro',
    requestPublished: 'Ufro publizéiert',
    requestClosed: 'Ufro zougemaach',
    requestCompleted: 'Ufro ofgeschloss',
    commentAdded: 'Neie Kommentar',
    offerReceived: 'Offer kritt',
    offerAccepted: 'Offer akzeptéiert',
    statusChanged: 'Status geännert',
    selectionStarted: 'Auswiel gestart',
    missionCreated: 'Transport erstallt',
    missionStatusUpdated: 'Transport aktualiséiert',
    transportPartnerNamed: 'Transportpartner',
    transportExtensionReceived: 'Transportverlängerung',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Astellungen',
    general: 'Allgemeng',
    system: 'System',
    email: 'E-Mail',
    sync: 'Synchroniséierung',
    security: 'Sécherheet',
    appearance: 'Ausgesinn',
    systemName: 'Systemnumm',
    systemEmail: 'System-E-Mail',
    maintenanceMode: 'Ënnerhaltsmodus',
    readOnlyMode: 'Nëmmen-liesen-Modus',
    emailEnabled: 'E-Mail aktivéiert',
    smtpHost: 'SMTP-Server',
    smtpPort: 'SMTP-Port',
    smtpUser: 'SMTP-Benotzer',
    smtpPassword: 'SMTP-Passwuert',
    senderEmail: 'Sender-E-Mail',
    senderName: 'Sendernumm',
    testEmail: 'Test-E-Mail schécken',
    syncEnabled: 'Synchroniséierung aktivéiert',
    syncUrl: 'Synchroniséierungs-URL',
    syncApiKey: 'Synchroniséierungs-API-Schlëssel',
    settingsSaved: 'Astellunge erfollegräich gespäichert',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Helpdesk-Titel',
    helpdeskEmail: 'Helpdesk-E-Mail',
    helpdeskPhone: 'Helpdesk-Telefon',
    helpdeskInfo: 'Helpdesk-Informatioun',
    realLifeSupport: 'Ënnerstëtzung am reellen Liewen',
    trainingMode: 'Trainingsmodus',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Audit-Protokoll',
    action: 'Aktioun',
    user: 'Benotzer',
    target: 'Zil',
    details: 'Detailer',
    timestamp: 'Zäitstempel',
    ipAddress: 'IP-Adress',
    noLogs: 'Keng Audit-Protokoller fonnt',
    searchLogs: 'Protokoller sichen...',
    filterByAction: 'No Aktioun filteren',
    filterByUser: 'No Benotzer filteren',
    exportLogs: 'Protokoller exportéieren',
    exportCsv: 'CSV exportéieren',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Exercice-Kontroll',
    currentDay: 'Aktuellen Dag',
    exerciseDay: 'Exercice-Dag',
    nextDay: 'Nächsten Dag',
    previousDay: 'Viregen Dag',
    resetExercise: 'Exercice zrécksetzen',
    startExercise: 'Exercice starten',
    endExercise: 'Exercice ophalen',
    dayReset: 'Dageszréckstellung',
    confirmReset: 'Sidd Dir sécher, datt Dir den Exercice-Dag zrécksetze wëllt? All Donnéeën vum aktuelle Dag ginn geläscht.',
    resetInProgress: 'Zréckstellung leeft...',
    maintenanceMode: 'Ënnerhaltsmodus',
    enableMaintenance: 'Ënnerhalt aktivéieren',
    disableMaintenance: 'Ënnerhalt desaktivéieren',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Datensynchroniséierung',
    syncStatus: 'Synchroniséierungsstatus',
    lastSync: 'Lescht Synchroniséierung',
    pendingItems: 'Offene Elementer',
    syncNow: 'Elo synchroniséieren',
    syncing: 'Synchroniséiert...',
    syncSuccess: 'Synchroniséierung erfollegräich',
    syncFailed: 'Synchroniséierung feelgeschloen',
    outbox: 'Ausgank',
    inbox: 'Agank',
    configuration: 'Konfiguratioun',
    targetUrl: 'Zil-URL',
    apiKey: 'API-Schlëssel',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Kaart',
    layers: 'Schichten',
    requests: 'Ufroen',
    hubs: 'Knotepunkten',
    facilities: 'Ariichtungen',
    routes: 'Strecken',
    showAll: 'Alles weisen',
    hideAll: 'Alles verstoppen',
    zoomIn: 'Eranzoomen',
    zoomOut: 'Erauszoomen',
    resetView: 'Ansiicht zrécksetzen',
    satellite: 'Satellit',
    terrain: 'Terrain',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Kaartekachelen gi lokal servéiert',
    tilesOnline: 'Kaartekachelen gi vun Online-Servere gelueden',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistiken',
    overview: 'Iwwersiicht',
    requestsByStatus: 'Ufroen no Status',
    requestsByCategory: 'Ufroen no Kategorie',
    requestsByNation: 'Ufroen no Natioun',
    offersByStatus: 'Offere no Status',
    patientsByCondition: 'Patiente no Zoustand',
    transportsByStatus: 'Transportë no Status',
    timeline: 'Zäitlinn',
    totalRequests: 'Gesamt Ufroen',
    totalOffers: 'Gesamt Offeren',
    totalPatients: 'Gesamt Patienten',
    totalTransports: 'Gesamt Transporten',
    averageResponseTime: 'Duerchschnëttlech Äntwertzeit',
    completionRate: 'Ofschlossquot',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Exercice-Statistiken',
    overview: 'Iwwersiicht',
    byCategory: 'No Kategorie',
    byNation: 'No Natioun',
    byDay: 'No Dag',
    totalPatientsMoved: 'Gesamt transportéiert Patienten',
    totalRequestsProcessed: 'Gesamt veraarbecht Ufroen',
    averageProcessingTime: 'Duerchschnëttlech Veraarbechtungszäit',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Fluxdiagramm',
    sankey: 'Sankey',
    nodeGraph: 'Knotegraph',
    refresh: 'Aktualiséieren',
    noData: 'Keng Fluxdaten disponibel',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Iwwer',
    version: 'Versioun',
    systemInfo: 'Systeminformatioun',
    buildDate: 'Erstellungsdatum',
    environment: 'Ëmfeld',
    description: 'ARCOS — Avancéiert Ufrokommunikatiounssystem',
    subtitle: 'Katastrophenhëllef a medizinesch Operatiounen',
    whatIsArcos: 'Wat ass ARCOS? – Erklärung fir Übungsteilnehmer',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Ënnerstëtzt vum MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – wou Virwëtz Zesummenaarbecht trëfft.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentatioun',
    gettingStarted: 'Ufänken',
    userGuide: 'Benotzerhandbuch',
    faq: 'Dacks gestallt Froen',
    troubleshooting: 'Feeleranalyse',
    apiReference: 'API-Referenz',
    downloadTemplate: 'Schabloun eroflueden',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Patientenimport',
    uploadFile: 'Fichier eroplueden',
    selectFile: 'Fichier auswielen',
    preview: 'Viruschau',
    importNow: 'Elo importéieren',
    importing: 'Importéiert...',
    importSuccess: '{{count}} Patiente erfollegräich importéiert',
    importFailed: 'Import feelgeschloen',
    downloadTemplate: 'Schabloun eroflueden',
    dragDrop: 'Zitt a looss e Fichier heihin, oder klickt fir en auszewielen',
    supportedFormats: 'Ënnerstëtzt Formater: XLSX, XLS, CSV',
    rowsFound: '{{count}} Zeile fonnt',
    validRows: '{{count}} gëlteg Zeilen',
    invalidRows: '{{count}} ongëlteg Zeilen',
    duplicateRows: '{{count}} Doublen',
    previewData: 'Daten kucken',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transportplanung',
    planRoute: 'Rout plangen',
    routeBuilder: 'Routeplaner',
    addWaypoint: 'Zwëschenhalt derbäisetzen',
    removeWaypoint: 'Zwëschenhalt ewechhuelen',
    estimatedDuration: 'Geschaten Dauer',
    distance: 'Distanz',
    selectVehicle: 'Gefier auswielen',
  },

  transportBooking: {
    title: 'Transportbuchung',
    bookTransport: 'Transport buchen',
    availableSlots: 'Disponibel Plazen',
    bookingConfirmed: 'Buchung bestätegt',
    cancelBooking: 'Buchung annuléieren',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapazitéitsplanung',
    totalCapacity: 'Gesamtkapazitéit',
    usedCapacity: 'Benotzten Kapazitéit',
    availableCapacity: 'Disponibel Kapazitéit',
    utilizationRate: 'Notzungsgrad',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Ressourceschablounen',
    dayTemplates: 'Dagsschablounen',
    createTemplate: 'Schabloun erstellen',
    editTemplate: 'Schabloun änneren',
    deleteTemplate: 'Schabloun läschen',
    templateName: 'Schablounennumm',
    applyTemplate: 'Schabloun uwenden',
    noTemplates: 'Keng Schalounen fonnt',
    confirmDelete: 'Sidd Dir sécher, datt Dir dës Schabloun läsche wëllt?',
    confirmApply: 'Sidd Dir sécher, datt Dir dës Schabloun uwende wëllt? Dat iwwerschreift déi existent Daten.',
    exportTemplates: 'Schalounen exportéieren',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Annoncëband',
    createAnnouncement: 'Annonce erstellen',
    editAnnouncement: 'Annonce änneren',
    deleteAnnouncement: 'Annonce läschen',
    message: 'Message',
    startTime: 'Startzäit',
    endTime: 'Endzäit',
    active: 'Aktiv',
    noAnnouncements: 'Keng Annoncen',
    confirmDelete: 'Sidd Dir sécher, datt Dir dës Annonce läsche wëllt?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Sichen...',
      noResults: 'Keng Resultater fonnt',
      showing: 'Weist {{from}} bis {{to}} vun {{total}}',
      rowsPerPage: 'Zeile pro Säit',
      previousPage: 'Vireg Säit',
      nextPage: 'Nächst Säit',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Bestätegen',
      cancel: 'Ofbriechen',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Net gespäichert Ännerungen',
      message: 'Dir hutt net gespäichert Ännerungen. Sidd Dir sécher, datt Dir dës Säit verloosse wëllt?',
      stay: 'Op der Säit bleiwen',
      leave: 'Säit verloossen',
    },
    // EmptyState
    emptyState: {
      noData: 'Keng Daten disponibel',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Eppes ass schifgelaf',
      message: 'En onerwaarte Feeler ass opgetrueden. Probéiert d\'Säit nei ze lueden.',
      retry: 'Nach eng Kéier probéieren',
    },
    // ExportButton
    exportButton: {
      export: 'Exportéieren',
      exporting: 'Exportéiert...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Drécken',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Entworf',
      review: 'Iwwerpréiwung',
      published: 'Publizéiert',
      selection: 'Auswiel',
      inTransit: 'Am Transport',
      completed: 'Ofgeschloss',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online-Instanz',
      message: 'Nëmmen-liesen-Modus. Daten gi vum primäre Server synchroniséiert.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Dir kuckt als',
      loggedInAs: 'ageloggt als {{nation}}',
      returnTo: 'Zréck op {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Säiten, Ufroen, Transporten sichen...',
      searching: 'Sicht...',
      noResults: 'Keng Resultater fir "{{query}}"',
      navigate: 'Navigéieren',
      select: 'Auswielen',
      close: 'Zoumaachen',
      pages: {
        dashboard: 'Tableau de bord',
        requests: 'Ufroen',
        transports: 'Transporten',
        map: 'Kaart',
        myPatients: 'Meng Patienten',
        flowDiagram: 'Fluxdiagramm',
        statistics: 'Statistiken',
        assets: 'Ressourcen',
        startPoints: 'Startpunkten / Knotepunkten',
        treatmentFacilities: 'Behandlungsarichtungen',
        users: 'Benotzer',
        settings: 'Astellungen',
        auditLogs: 'Audit-Protokoll',
        exerciseControl: 'Exercice-Kontroll',
        dataSync: 'Datensynchroniséierung',
        patientImport: 'Patientenimport',
        notifications: 'Notifikatiounen',
        documentation: 'Dokumentatioun',
      },
      actions: {
        importPatientsJson: 'Patienten importéieren (JSON)',
        importPatientsExcel: 'Patienten importéieren (Excel)',
        importUsers: 'Benotzer importéieren (Excel)',
        importAssetTemplates: 'Asset-Virlagen importéieren (Excel)',
        importDayTemplates: 'Dagsvirlag-Aträg importéieren (Excel)',
        exportRequests: 'Ufroen exportéieren (Excel)',
        exportPatients: 'Patienten exportéieren (Excel)',
        exportUsers: 'Benotzer exportéieren (Excel)',
        exportCredentials: 'Zougangsdaten exportéieren (PDF)',
        exportAuditExcel: 'Auditprotokoll exportéieren (Excel)',
        exportAuditPdf: 'Auditprotokoll exportéieren (PDF)',
        pagePatientImport: 'Säit fir Patientenimport',
        pageRequestDetail: 'Säit fir Ufrodetailer',
        pageUsers: 'Säit fir Benotzerverwaltung',
        pageAssetTemplates: 'Säit fir Asset-Virlagen',
        pageDayTemplates: 'Säit fir Dagsvirlagen',
        pageRequests: 'Säit fir Ufrolëscht',
        pageAuditLogs: 'Säit fir Auditprotokoll',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sëtzung leeft of',
      message: 'Är Sëtzung leeft a(n) <strong>{{time}}</strong> of. Späichert Är Aarbecht a loggt Iech nach eng Kéier an fir weiderzefueren.',
      dismiss: 'Ofweisen',
      logoutNow: 'Elo ausloggen',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: '4 Zäitzone auswielen',
      configure: 'Zäitzone konfiguréieren',
      reset: 'Zrécksetzen',
      apply: 'Uwenden',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Standuert auswielen',
      latitude: 'Breedegréid',
      longitude: 'Längegréid',
      clickToSelect: 'Klickt op d\'Kaart fir e Standuert auszewielen',
    },
    // Modal
    modal: {
      close: 'Zoumaachen',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Heem',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Systemënnerhalt',
    message: 'De System gëtt fir den nächsten Exercice-Dag zréckgesat. Waart w.e.g. bis de Prozess ofgeschloss ass.',
    autoRefresh: 'Dës Säit gëtt automatesch aktualiséiert wann de System erëm disponibel ass.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Mindestens 10 Zeechen',
    uppercase: '1 Groussbuschstaf',
    lowercase: '1 Klengbuschstaf',
    digit: '1 Ziffer',
    special: '1 Spezialtzeichen',
  },
};

export default lb;
